import { render, staticRenderFns } from "./obligation.vue?vue&type=template&id=76eacd46&"
import script from "./obligation.js?vue&type=script&lang=js&"
export * from "./obligation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eacd46')) {
      api.createRecord('76eacd46', component.options)
    } else {
      api.reload('76eacd46', component.options)
    }
    module.hot.accept("./obligation.vue?vue&type=template&id=76eacd46&", function () {
      api.rerender('76eacd46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/obligation/obligation.vue"
export default component.exports